var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.workout)?_c('WorkoutIntro',{attrs:{"workout":_vm.workout,"christmasWorkout":_vm.christmasOverview === 'christmas' ? true : false}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }